import React, {ChangeEvent} from 'react';

import {PageHeadline} from 'src/components/page-headline/page-headline';
import {EventUpdateSubscription} from 'src/modules/user-settings/event-update-subscription/event-update-subscription';
import {NotificationType} from 'src/modules/user-settings/typedefs';
import {
    EMAIL_APPROVER_NOTIFICATION_INFO,
    EMAIL_REVIEWER_NOTIFICATION_INFO,
    EMAIL_WATCHER_NOTIFICATION_INFO,
    SLACK_APPROVER_NOTIFICATION_INFO,
    SLACK_REVIEWER_NOTIFICATION_INFO,
} from 'src/modules/user-settings/user-settings-hovers';
import {Role} from 'src/openapi/models/Role';
import {UserSettings} from 'src/openapi/models/UserSettings';

import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';
import StateButton from '@pb/kit-component-state-button';
import {LocalStorage} from '@pb/kit-util-client-storage';

type Props = {
    userSettings: UserSettings | null,
    onChange: (event: ChangeEvent<HTMLInputElement>) => void,
};

export const UserSettingsView = ({userSettings, onChange}: Props) => {
    const userRoles = LocalStorage.get('user')?.roles || [];

    return (
        <>
            <PageHeadline caption="User Settings"/>
            {userSettings ? (
                <Group gap="xxxl">
                    <Group direction="v">
                        <Group gap="l" direction="v">
                            <Group direction="v">
                                <Group gap="xs" alignItems="center">
                                    <Item>Email Watcher Notification</Item>
                                    <Dropdown
                                        hoverEnabled={true}
                                        clickEnabled={false}
                                        maxWidth={500}
                                        anchor={({anchorRef, getAnchorProps}) => (
                                            <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                        )}>
                                        {EMAIL_WATCHER_NOTIFICATION_INFO}
                                    </Dropdown>
                                </Group>
                                <StateButton
                                    captions={{off: 'OFF', on: 'ON'}}
                                    name={NotificationType.EMAIL_WATCHER_NOTIFICATION}
                                    checked={userSettings.emailWatcherNotification}
                                    onChange={onChange}
                                />
                            </Group>
                        </Group>
                        {userRoles.includes(Role.ROLE_UDEDT_REVIEWER) && (
                            <Group direction="v">
                                <Group direction="v">
                                    <Group gap="xs" alignItems="center">
                                        <Item>Email Reviewer Notification</Item>
                                        <Dropdown
                                            hoverEnabled={true}
                                            clickEnabled={false}
                                            maxWidth={500}
                                            anchor={({anchorRef, getAnchorProps}) => (
                                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                            )}>
                                            {EMAIL_REVIEWER_NOTIFICATION_INFO}
                                        </Dropdown>
                                    </Group>
                                    <StateButton
                                        captions={{off: 'OFF', on: 'ON'}}
                                        name={NotificationType.EMAIL_REVIEWER_NOTIFICATION}
                                        checked={userSettings.emailReviewerNotification}
                                        onChange={onChange}
                                    />
                                </Group>
                                <Group direction="v">
                                    <Group gap="xs" alignItems="center">
                                        <Item>Slack Reviewer Notification</Item>
                                        <Dropdown
                                            hoverEnabled={true}
                                            clickEnabled={false}
                                            maxWidth={500}
                                            anchor={({anchorRef, getAnchorProps}) => (
                                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                            )}>
                                            {SLACK_REVIEWER_NOTIFICATION_INFO}
                                        </Dropdown>
                                    </Group>
                                    <StateButton
                                        captions={{off: 'OFF', on: 'ON'}}
                                        name={NotificationType.SLACK_REVIEWER_NOTIFICATION}
                                        checked={userSettings.slackReviewerNotification}
                                        onChange={onChange}
                                    />
                                </Group>
                            </Group>
                        )}
                        {userRoles.includes(Role.ROLE_UDEDT_APPROVER) && (
                            <Group direction="v">
                                <Group direction="v">
                                    <Group gap="xs" alignItems="center">
                                        <Item>Email Approver Notification</Item>
                                        <Dropdown
                                            hoverEnabled={true}
                                            clickEnabled={false}
                                            maxWidth={500}
                                            anchor={({anchorRef, getAnchorProps}) => (
                                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                            )}>
                                            {EMAIL_APPROVER_NOTIFICATION_INFO}
                                        </Dropdown>
                                    </Group>
                                    <StateButton
                                        captions={{off: 'OFF', on: 'ON'}}
                                        name={NotificationType.EMAIL_APPROVER_NOTIFICATION}
                                        checked={userSettings.emailApproverNotification}
                                        onChange={onChange}
                                    />
                                </Group>
                                <Group direction="v">
                                    <Group gap="xs" alignItems="center">
                                        <Item>Slack Approver Notification</Item>
                                        <Dropdown
                                            hoverEnabled={true}
                                            clickEnabled={false}
                                            maxWidth={500}
                                            anchor={({anchorRef, getAnchorProps}) => (
                                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                            )}>
                                            {SLACK_APPROVER_NOTIFICATION_INFO}
                                        </Dropdown>
                                    </Group>
                                    <StateButton
                                        captions={{off: 'OFF', on: 'ON'}}
                                        name={NotificationType.SLACK_APPROVER_NOTIFICATION}
                                        checked={userSettings.slackApproverNotification}
                                        onChange={onChange}
                                    />
                                </Group>
                            </Group>
                        )}
                    </Group>
                    <EventUpdateSubscription userSettings={userSettings} onChangeStateButton={onChange}/>
                </Group>
            ) : null}
        </>
    );
};
